import { Image } from "antd";
import { roundNumber, serverImgFullPath } from "../../../utils/Common";
import AdditionGroupsList from "./AdditionGroupsList";
import Helper from "../../../utils/Helper";
import { getFoodAddOnsTotalPrice } from "../../../services/order-details-service";

export default function OrderedFoodComponent({ food }) {
  return (
    <div className="w-full bg-[#F1F1F1] relative">
      <div className="flex items-center">
        <div className="h-[100px]">
          {/* image */}
          <Image
            src={serverImgFullPath(food.image)}
            fallback="https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/plateicon.svg"
            alt={food.name}
            height={100}
            width={100}
            className="p-2"
            style={{ borderRadius: "20px" }}
          />
        </div>
        <div className="flex items-end w-full px-[10px]">
          <div className="w-[50%]">
            <h1 className="font-p_medium text-[16px] mb-2 break-words break-all whitespace-normal">{food.name}</h1>
            {food.option.name !== "System Default" && 
            <p className="text-[14px]">
              <span className="font-p_medium">Variant: </span>
              <span className="font-p_regular break-words break-all whitespace-normal">
                {food.option.name}
              </span>
            </p>
            }
            <p className="text-[14px]">
              {food.addOns.length > 0 && (
                <span className="font-p_medium">
                  Add-ons: <span className="font-p_regular break-words break-all whitespace-normal">{food.addOns.map((adOn) => adOn.name).join(", ")}</span>
                </span>
              )}
            </p>
          </div>

          {/* quantity */}
          <div className="w-[20%] font-p_regular text-[14px] text-right pr-[40px]">
            <div className="pb-1.5">
              Quantity: <span className="font-p_bold">{food.quantity}</span>
            </div>
            <div>
              Weight: <span className="font-p_bold">{food.option.weight}</span>
            </div>
          </div>

          {/* price */}
          <div className="w-[30%] h-full flex flex-col items-end justify-center">
            <div className="pb-1">
              <span className="font-p_semibold text-[16px]">Food Price: </span>
              <span className="font-p_bold text-[18px]">{(roundNumber(food.quantity * food.option.price)).toFixed(2)} TK</span>
            </div>
            {food.addOns.length > 0 && 
            <div className="">
              <span className="font-p_semibold text-[16px]">Add-ons Price: </span>
              <span className="font-p_bold text-[18px]">{(getFoodAddOnsTotalPrice(food.addOns)).toFixed(2)} TK</span>
            </div>
            }
          </div>
        </div>
      </div>

      {/*Addition Groups*/}
      <div className="p-2">
        <AdditionGroupsList additionGroups={Helper.transformAdditionGroups(food.additionGroups)} />
      </div>

      {/* set menus included foods */}
      {food.includes && food.includes.length > 0 && (
        <div className="px-[10px]">
          <h1 className="font-p_semibold text-[16px] mb-3.5 ml-[100px]">Includes</h1>
          <div className="ml-[90px]">
            {food.includes.map((includedFood, idx) => {
              return (
                <div
                  key={`${includedFood.foodId}-${idx}`}
                  className="flex items-center mb-2 py-2 px-[10px]  
          border-b border-b-[1px] border-b-black space-x-4"
                >
                  <div className="w-[51%]">
                    <h1 className="font-p_medium text-[16px] mb-1.5 break-words break-all whitespace-normal">{includedFood.foodName}</h1>
                    <p className="font-p_regular text-[14px] break-words break-all whitespace-normal">
                      Variant: {includedFood.optionName === "System Default" ? "" : includedFood.optionName}
                    </p>
                  </div>
                  <div className="w-[49%] font-p_regular text-[14px]">
                    <div>
                      Quantity: <span className="font-p_bold">{includedFood.quantity}</span>
                    </div>
                    <div>
                      Weight: <span className="font-p_bold">{includedFood.weight}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
